module.exports = {
  data: {
    categories: [
      {
        categorySlug: 'outlook',
        homePageButtonStyles: {
          width: '13%',
          height: '35.9%',
          top: '46%',
          left: '21.25%',
        },
        segments: [
          {
            slideNumber: 0,
            actionButtonStyles: {
              width: '13%',
              height: '5.3%',
              top: '28.6%',
              left: '14%',
            },
          },
          {
            slideNumber: 1,
            actionButtonStyles: {
              width: '46.5%',
              height: '3.3%',
              top: '25.9%',
              left: '27.4%',
            },
          },
          {
            slideNumber: 2,
            actionButtonStyles: {
              width: '5.41%',
              height: '2.15%',
              top: '23.05%',
              left: '6.25%',
            },
          },
          {
            slideNumber: 3,
            actionButtonStyles: {
              width: '2.1%',
              height: '2.58%',
              top: '22.8%',
              left: '56.85%',
            },
          },
          {
            slideNumber: 4,
            actionButtonStyles: {
              width: '44.2%',
              height: '9.1%',
              top: '42.3%',
              left: '28.5%',
            },
          },
          {
            slideNumber: 5,
            actionButtonStyles: {
              width: '4.15%',
              height: '2.24%',
              top: '48.7%',
              left: '68.2%',
            },
          },
          {
            slideNumber: 6,
            actionButtonStyles: {
              width: '44.2%',
              height: '2.7%',
              top: '62.3%',
              left: '28.5%',
            },
          },
          {
            slideNumber: 7,
            actionButtonStyles: {
              width: '3.35%',
              height: '2.1%',
              top: '65.9%',
              left: '28.5%',
            },
          },
          {
            slideNumber: 8,
          },
        ],
      },
      {
        categorySlug: 'chat',
        homePageButtonStyles: {
          width: '13%',
          height: '35.9%',
          top: '46%',
          left: '36%',
        },
        segments: [
          {
            slideNumber: 0,
            actionButtonStyles: {
              width: '26.8%',
              height: '3.3%',
              top: '75.2%',
              left: '25.9%',
            },
          },
          {
            slideNumber: 1,
            actionButtonStyles: {
              width: '26.8%',
              height: '5.9%',
              top: '72.75%',
              left: '25.9%',
            },
          },
          {
            slideNumber: 2,
            actionButtonStyles: {
              width: '26.8%',
              height: '5.9%',
              top: '72.75%',
              left: '25.9%',
            },
          },
          {
            slideNumber: 3,
          },
        ],
      },
      {
        categorySlug: 'word',
        homePageButtonStyles: {
          width: '13%',
          height: '35.9%',
          top: '46%',
          left: '51%',
        },
        segments: [
          {
            slideNumber: 0,
            actionButtonStyles: {
              width: '2.7%',
              height: '2.1%',
              top: '21.6%',
              left: '57.9%',
            },
          },
          {
            slideNumber: 1,
            actionButtonStyles: {
              width: '26.5%',
              height: '8.9%',
              top: '30.1%',
              left: '25.3%',
            },
          },
          {
            slideNumber: 2,
            actionButtonStyles: {
              width: '18.35%',
              height: '2.4%',
              top: '59.5%',
              left: '33.8%',
            },
          },
          {
            slideNumber: 3,
            actionButtonStyles: {
              width: '4%',
              height: '2.5%',
              top: '74.5%',
              left: '25.95%',
            },
          },
          {
            slideNumber: 4,
            actionButtonStyles: {
              width: '1.4%',
              height: '2.4%',
              top: '30.3%',
              left: '24.55%',
            },
          },
          {
            slideNumber: 5,
            actionButtonStyles: {
              width: '1.4%',
              height: '2.4%',
              top: '67.3%',
              left: '25.57%',
            },
          },
          {
            slideNumber: 6,
          },
        ],
      },
      {
        categorySlug: 'teams',
        homePageButtonStyles: {
          width: '13%',
          height: '35.9%',
          top: '46%',
          left: '65.6%',
        },
        segments: [
          {
            slideNumber: 0,
            actionButtonStyles: {
              width: '1.52%',
              height: '2.9%',
              top: '19.9%',
              left: '61.57%',
            },
          },
          {
            slideNumber: 1,
            actionButtonStyles: {
              width: '12.65%',
              height: '7.85%',
              top: '72.55%',
              left: '61.3%',
            },
          },
          {
            slideNumber: 2,
            actionButtonStyles: {
              width: '12.65%',
              height: '7.85%',
              top: '72.55%',
              left: '61.3%',
            },
          },
          {
            slideNumber: 3,
            actionButtonStyles: {
              width: '0.64%',
              height: '1.1%',
              top: '53.76%',
              left: '65.45%',
            },
          },
          {
            slideNumber: 4,
          },
        ],
      },
      {
        categorySlug: 'excel',
        homePageButtonStyles: {
          width: '13%',
          height: '35.9%',
          top: '46%',
          left: '80.5%',
        },
        segments: [
          {
            slideNumber: 0,
            actionButtonStyles: {
              width: '1.65%',
              height: '5%',
              top: '21.5%',
              left: '44.9%',
            },
          },
          {
            slideNumber: 1,
            actionButtonStyles: {
              width: '12.65%',
              height: '7.85%',
              top: '68.75%',
              left: '61.3%',
            },
          },
          {
            slideNumber: 2,
            actionButtonStyles: {
              width: '12.65%',
              height: '7.85%',
              top: '68.75%',
              left: '61.3%',
            },
          },
          {
            slideNumber: 3,
            actionButtonStyles: {
              width: '3.35%',
              height: '1.85%',
              top: '74.7%',
              left: '31.1%',
            },
          },
          {
            slideNumber: 4,
            actionButtonStyles: {
              width: '12.65%',
              height: '7.85%',
              top: '68.75%',
              left: '61.3%',
            },
          },
          {
            slideNumber: 5,
            actionButtonStyles: {
              width: '12.65%',
              height: '7.85%',
              top: '68.75%',
              left: '61.3%',
            },
          },
          {
            slideNumber: 6,
            actionButtonStyles: {
              width: '3.35%',
              height: '1.85%',
              top: '74.7%',
              left: '31.1%',
            },
          },
          {
            slideNumber: 7,
            actionButtonStyles: {
              width: '12.65%',
              height: '7.85%',
              top: '68.75%',
              left: '61.3%',
            },
          },
          {
            slideNumber: 8,
            actionButtonStyles: {
              width: '3.35%',
              height: '1.85%',
              top: '74.7%',
              left: '31.1%',
            },
          },
          {
            slideNumber: 9,
          },
        ],
      },
    ],
  },
}
